import { Box } from '@rbilabs/universal-components';

export const OrderSummaryContainer = Box.withConfig({
  width: 'full',
  marginTop: {
    base: '$4',
    md: '$8',
  },
});
